import {
  FontIcon,
  FontSizes,
  Icon,
  Label,
  NeutralColors,
  Panel,
  PanelType,
  Spinner,
} from "@fluentui/react";
import { useCallback, useEffect, useState } from "react";

import { PanelFooterGestionDocumentos } from "../general/PanelFooterGestionDocumentos";
import { _helperIBaseResponse } from "../../../Interfaces/gestionDocumentos/ITipoDocumento";
import grupoDocumentoService from "../../../services/gestionDocumentos/grupoDocumentoService";
import { IHistorialDocumento } from "../../../Interfaces/gestionDocumentos/IHistorialDocumento";
import themeBase from "../../../utils/theme/themeBase";
import { DownloadFiles } from "../general/DownloadFile";

interface IPanelHistorialArchivo {
  isOpen: boolean;
  onDismiss: () => void;
  onRenderTable: () => void;
  archivoId: string;
}

export const PanelHistorialArchivo = (props: IPanelHistorialArchivo) => {
  const [loadind, setloading] = useState(false);

  const [data, setData] = useState<IHistorialDocumento[]>([]);
  // const [data, setData] = useState<IBaseResponseApi>(_helperIBaseResponse);

  useEffect(() => {
    if (props.isOpen) {
      _getData();
    }
  }, [props.isOpen]);

  const onRenderHeader = useCallback(
    () => (
      <>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            margin: "0px 24px",
            width: "100%",
          }}
        >
          <div
            style={{
              color: NeutralColors.gray130,
              fontSize: FontSizes.size20,
            }}
          >
            Historial Documento
          </div>
          <div
            style={{
              color: NeutralColors.gray130,
              fontSize: FontSizes.size12,
            }}
          ></div>
        </div>
      </>
    ),
    []
  );

  const _getData = () => {
    if (props.archivoId) {
      setloading(true);
      grupoDocumentoService
        .getHistorial(props.archivoId)
        .then((res) => {
          if (res.status === 200) {
            setData(res.data);
            setloading(false);
          }
        })
        .catch((err: Error) => {
          console.log(err);
        });
    }
  };

  const onRenderFooter = useCallback(
    () => (
      <>
        <PanelFooterGestionDocumentos
          texto="Crear"
          texto2={"Cancelar"}
          onClick={() => {}}
          onDismiss={() => {
            // _goback();
          }}
          disableButton={false}
        />
      </>
    ),
    [props.onDismiss]
  );

  const limpiarResponse = () => {
    setData([]);
    setloading(false);
    props.onDismiss();
  };

  const _goback = () => {
    limpiarResponse();
  };

  return (
    <Panel
      isOpen={props.isOpen}
      onDismiss={_goback}
      onRenderHeader={onRenderHeader}
      //   onRenderFooter={onRenderFooter}
      type={PanelType.custom}
      customWidth="400px"
      isFooterAtBottom={true}
      isLightDismiss={true}
    >
      <>
        {/* <pre>{JSON.stringify(archivo, null, 2)}</pre> */}
        {loadind && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
            }}
          >
            <Spinner label="Cargando..." style={{ fontSize: 20 }} />
          </div>
        )}
        <br />
        {!loadind && data.length > 0 ? (
          <>
            {data.map((element) => (
              <div key={props.archivoId}>
                <div
                  id="contenedorGeneral"
                  style={{ display: "flex", gap: "35px" }}
                >
                  {/* Iconos */}
                  <div
                    id="iconos"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "20px",
                        // backgroundColor: "rgb(0, 120, 210)",
                        padding: "20%",
                        borderRadius: "10%",
                        border: "solid 1px rgb(0, 120, 210)",
                        color: "rgb(0, 120, 212)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      id="calendario"
                    >
                      {/* <Calendar24Regular /> */}
                      <Icon
                        iconName="Clock"
                        style={{
                          cursor: "pointer",
                          color: "rgb(0, 120, 210)",
                        }}
                        className={themeBase.classNamesIcon.iconFont}
                      />
                    </div>
                    <hr
                      style={{
                        border: "none",
                        borderLeft: "1px solid #999",
                        height: "100%",
                      }}
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "5px",
                    }}
                  >
                    <div>
                      <b>Fecha:</b>
                      <br />
                      <span>{element.fecha}</span>
                    </div>

                    <div>
                      <b>Modificado por:</b>
                      <br />
                      <span>{element.usuario}</span>
                    </div>

                    <div>
                      <b>Acción</b>
                      <br />
                      <span>{element.observacion}</span>
                    </div>
                    <div style={{ width: "20px" }}>
                      <DownloadFiles url={element.urlDocumento} nombre="File" />
                    </div>
                  </div>
                </div>
                <br />
              </div>
            ))}
          </>
        ) : (
          <>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
              }}
            >
              <Label color="rgb(0, 120, 210)">¡No existen registros!</Label>
            </div>
          </>
        )}
      </>
    </Panel>
  );
};
